module.exports = __webpack_public_path__ + "img/13.225ae4ac.webp";